let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3t6fF"), load("tLGOl")]).then(() => parcelRequire('anKEx'));